
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  InputNumber,
  Button,
} from 'element-ui';
import { IResource } from '@/types/course.d';
import api from '@/api/course';
import publicApi from '@/api/public';
import FormMixin from './formMxin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    InputNumber,
    Button,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: true,
    default: false,
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private knowledges: any = [];


  mounted() {
    publicApi.getType('knowledge').then((res: any) => {
      this.knowledges = res;
    });
    if (this.title.includes('修改')) this.form = this.oldForm;
    else this.form.cid = this.oldForm.stepPid;
  }

  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        const data = new FormData();
        Object.keys(this.form).forEach((index) => {
          if (this.form[index] || this.form[index] === 0) data.append(index, this.form[index]);
        });
        if (title.includes('修改')) {
          api.editKnowedge(this.form).then(() => {
            this.reset(true, true);
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addKnowedge(data).then(() => {
            this.reset(true, true);
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh', this.form.stepPid);
    this.resetForm();
  }
}
